import { IJBPPlanningItem } from '../models/IJBPPlanning'
import { OVERALL_CATEGORY } from '../planning/config'

export const cleanPlanningItemForApi = (
  data: IJBPPlanningItem[],
  fyear: number,
  isCollapsed: boolean
) => {
  const cleanData = data
    .filter(
      (el) =>
        (el.IsTarget && el.FYear >= fyear) ||
        (el.IsActuals && (el.FYear >= fyear || el.FYear === fyear - 1))
    )
    .map((el) => {
      const isL3Overall = el.L3Category === OVERALL_CATEGORY
      const isCollapsedValue = isCollapsed ? 1 : 0

      return {
        IsCollapsed: isL3Overall ? el.IsCollapsed : isCollapsedValue,
        IsChanged: el.IsChanged, // Item
        IsChangedSoB: el.IsChangedSoB, // Item

        Comment: el.Comment,
        JustificationSob: el.JustificationSob,
        Justification: el.Justification,
        JustificationContractual: el.JustificationContractual,
        JustificationTransactional: el.JustificationTransactional,
        JustificationUnits: el.JustificationUnits,
        JustificationUnitsContractual: el.JustificationUnitsContractual,
        JustificationUnitsTransactional: el.JustificationUnitsTransactional,

        PartnerId: el.PartnerId,
        FYear: el.FYear,
        ProgramTypes: el.ProgramTypes,
        Category: el.Category,

        FQuarter: el.FQuarter,
        SubCategory: el.SubCategory,

        L3Category: el.L3Category,

        IsActuals: el.IsActuals,
        IsTarget: el.IsTarget,
        //IsQuota: number

        IsNoPlan: el.IsNoPlan,
        IsNoPlanContractual: el.IsNoPlanContractual,

        // Global Partner

        GlobalCategory: el.GlobalCategory ? el.GlobalCategory : undefined,

        // Commercial

        // USD
        SellThruSumUSDTNet: el.SellThruSumUSDTNet,
        SellThruSumUSDNet: el.SellThruSumUSDNet,
        SellThruSumUSDNdp: el.SellThruSumUSDNdp,
        // LC
        SellThruSumLCTNet: el.SellThruSumLCTNet,
        SellThruSumLCNet: el.SellThruSumLCNet,
        SellThruSumLCNdp: el.SellThruSumLCNdp,
        // Units
        SellThruUnitsTNet: el.SellThruUnitsTNet,
        SellThruUnits: el.SellThruUnits, // No Net suffix
        SellThruUnitsNdp: el.SellThruUnitsNdp,

        // Commercial Contractual planing

        // USD
        ContractualSumUSDTNet: el.ContractualSumUSDTNet,
        ContractualSumUSDNet: el.ContractualSumUSDNet,
        ContractualSumUSDNdp: el.ContractualSumUSDNdp,
        // LC
        ContractualSumLCTNet: el.ContractualSumLCTNet,
        ContractualSumLCNet: el.ContractualSumLCNet,
        ContractualSumLCNdp: el.ContractualSumLCNdp,
        // Units
        ContractualUnitsTNet: el.ContractualUnitsTNet,
        ContractualUnits: el.ContractualUnits, // No Net suffix
        ContractualUnitsNdp: el.ContractualUnitsNdp,

        // SoB

        SoB: el.SoB,
      }
    })

  return cleanData
}
